<template>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="bg-light border-bottom-0 modal-header">
        <h5 class="modal-title">
          {{ $t("Set Password") }}
        </h5>
        <button
          type="button"
          class="close"
          @click="resetvalue"
          data-dismiss="modal"
        >
          &times;
        </button>
      </div>
      <div class="modal-body">
        <section id="ModalNewPassword">
          <form>
            <fieldset v-if="message">
              <div class="form-group">
                <div class="alert alert-danger">
                  <i class="fa fa-info-circle" /> {{ $t(message)+' '+limit+' '+$t(times) }}
                </div>
              </div>
            </fieldset>
            <fieldset>
              <div
                class="form-group form-group-feedback form-group-feedback-right"
                :class="{'form-group-error': $v.form.password.$error}"
              >
                <div 
                  class="popover bs-popover-right valid-password"
                  v-if="
                    $v.form.password.required && !$v.form.password.minLength && referCode.length == 0 ||
                      $v.form.password.required && !$v.form.password.maxLength && referCode.length == 0 ||
                      $v.form.password.required && !$v.form.password.continuously && referCode.length == 0 ||
                      $v.form.password.required && !$v.form.password.uppercase && referCode.length == 0 ||
                      $v.form.password.required && !$v.form.password.lowercase && referCode.length == 0 ||
                      $v.form.password.required && !$v.form.password.number && referCode.length == 0 ||
                      $v.form.password.required && !$v.form.password.special && referCode.length == 0  
                  "
                >
                  <div class="arrow valid-arrow" />
                  <div class="popover-body text-size-13">
                    <div class="d-flex">
                      <i
                        class="icon-cancel-circle2 text-danger mt-1 mr-2 text-size-13"
                        v-if="!$v.form.password.minLength"
                      />
                      <i
                        class="icon-checkmark-circle text-success mt-1 mr-2 text-size-13"
                        v-else
                      />
                      {{ $t('Password must have at least') + ' ' + $v.form.password.$params.minLength.min + ' ' + $t('digits.') }}
                    </div>
                    <div class="d-flex">
                      <i
                        class="icon-cancel-circle2 text-danger mt-1 mr-2 text-size-13"
                        v-if="!$v.form.password.maxLength"
                      />
                      <i
                        class="icon-checkmark-circle text-success mt-1 mr-2 text-size-13"
                        v-else
                      />
                      {{ $t('Password must have at most') + ' ' + $v.form.password.$params.maxLength.max + ' ' + $t('digits.') }}
                    </div>
                    <div class="d-flex">
                      <i
                        class="icon-cancel-circle2 text-danger mt-1 mr-2 text-size-13"
                        v-if="!$v.form.password.continuously"
                      />
                      <i
                        class="icon-checkmark-circle text-success mt-1 mr-2 text-size-13"
                        v-else
                      />
                      {{ $t('Consecutive letters or numbers cannot be used') }}
                    </div>
                    <div class="d-flex">
                      <i
                        class="icon-cancel-circle2 text-danger mt-1 mr-2 text-size-13"
                        v-if="!$v.form.password.uppercase"
                      />
                      <i
                        class="icon-checkmark-circle text-success mt-1 mr-2 text-size-13"
                        v-else
                      />
                      {{ $t('At least 1 uppercase letter') }}
                    </div>
                    <div class="d-flex">
                      <i
                        class="icon-cancel-circle2 text-danger mt-1 mr-2 text-size-13"
                        v-if="!$v.form.password.lowercase"
                      />
                      <i
                        class="icon-checkmark-circle text-success mt-1 mr-2 text-size-13"
                        v-else
                      />
                      {{ $t('At least 1 lowercase letter') }}
                    </div>
                    <div class="d-flex">
                      <i
                        class="icon-cancel-circle2 text-danger mt-1 mr-2 text-size-13"
                        v-if="!$v.form.password.number"
                      />
                      <i
                        class="icon-checkmark-circle text-success mt-1 mr-2 text-size-13"
                        v-else
                      />
                      {{ $t('At least 1 number') }}
                    </div>
                    <div class="d-flex">
                      <i
                        class="icon-cancel-circle2 text-danger mt-1 mr-2 text-size-13"
                        v-if="!$v.form.password.special"
                      />
                      <i
                        class="icon-checkmark-circle text-success mt-1 mr-2 text-size-13"
                        v-else
                      />
                      {{ $t('At least 3 special characters') }}
                    </div>
                  </div>
                </div>
                <label>{{ $t("New password") }}</label>
                <div class="input-group input-group-lg">
                  <input
                    :type="passwordFieldType" 
                    :class="['form-control' ,
                             $v.form.password.required && referCode.length == 0 ? 
                               !$v.form.password.minLength ||
                               !$v.form.password.maxLength ||
                               !$v.form.password.continuously ||
                               !$v.form.password.uppercase ||
                               !$v.form.password.lowercase ||
                               !$v.form.password.number ||
                               !$v.form.password.special ?
                                 'border-danger' : 'border-success' 
                               : ''
                    ]"
                    :placeholder="$t('Password')" 
                    v-model.trim.lazy="$v.form.password.$model" 
                    @keyup="realtime($event,'password')"
                    style="font-family: arial" 
                  >
                  <div
                    v-if="
                      $v.form.password.required && !$v.form.password.minLength && referCode.length == 0 ||
                        $v.form.password.required && !$v.form.password.maxLength && referCode.length == 0 ||
                        $v.form.password.required && !$v.form.password.continuously && referCode.length == 0 ||
                        $v.form.password.required && !$v.form.password.uppercase && referCode.length == 0 ||
                        $v.form.password.required && !$v.form.password.lowercase && referCode.length == 0 ||
                        $v.form.password.required && !$v.form.password.number && referCode.length == 0 ||
                        $v.form.password.required && !$v.form.password.special && referCode.length == 0 
                    "
                    class="form-control-feedback text-danger icon-mark-2"
                  >
                    <i class="icon-cancel-circle2" />
                  </div>
                  <div
                    v-else-if="$v.form.password.required && referCode.length == 0"
                    class="form-control-feedback text-success icon-mark-2"
                  >
                    <i class="icon-checkmark-circle" />
                  </div>
                  <span class="input-group-append">
                    <span
                      class="input-group-text pointer"
                      @click="switchVisibiliry"
                    ><i :class="iconpassword" /></span>
                  </span>
                </div>
                <div
                  v-if="!$v.form.password.required"
                  class="validation-invalid-label"
                >
                  {{ $t('Please enter password.') }}
                </div>
                <div
                  v-else-if="!$v.form.password.minLength && referCode.length != 0"
                  class="validation-invalid-label"
                >
                  {{ $t("Password must have at least") + " " + $v.form.password.$params.minLength.min + " " + $t("digits.") }}
                </div>
                <div
                  v-else-if="!$v.form.password.maxLength && referCode.length != 0"
                  class="validation-invalid-label"
                >
                  {{ $t("Password must have at most") + " " + $v.form.password.$params.maxLength.max + " " + $t("digits.") }}
                </div>
              </div>
              <div
                class="form-group form-group-feedback form-group-feedback-right"
                :class="{'form-group-error': $v.form.confirmpassword.$error}"
              >
                <label>{{ $t("Confirm Password") }}</label>
                <div class="input-group input-group-lg">
                  <input
                    :type="confirmpasswordFieldType" 
                    :class="['form-control' ,
                             $v.form.confirmpassword.required && referCode.length == 0 ? 
                               !$v.form.confirmpassword.sameAsPassword ?
                                 'border-danger' : 'border-success' 
                               : ''
                    ]"
                    :placeholder="$t('Confirm Password')" 
                    v-model.trim.lazy="$v.form.confirmpassword.$model" 
                    @keyup="realtime($event,'confirmpassword')"
                    style="font-family: arial" 
                    id="confirmnewpassword"
                  >
                  <div
                    v-if="$v.form.confirmpassword.required && !$v.form.confirmpassword.sameAsPassword && referCode.length == 0"
                    class="form-control-feedback text-danger icon-mark-2"
                  >
                    <i class="icon-cancel-circle2" />
                  </div>
                  <div
                    v-else-if="$v.form.confirmpassword.required && referCode.length == 0"
                    class="form-control-feedback text-success icon-mark-2"
                  >
                    <i class="icon-checkmark-circle" />
                  </div>
                  <span
                    class="input-group-append"
                    @click="confirmswitchVisibiliry"
                  >
                    <button
                      type="button"
                      class="btn btn-light btn-icon"
                      tabindex="-1"
                    ><i :class="iconconfirmpassword" /></button>
                  </span>
                </div>
                <div
                  v-if="!$v.form.confirmpassword.required"
                  class="validation-invalid-label"
                >
                  {{ $t('Please enter confirm password.') }}
                </div>
                <div
                  v-else-if="!$v.form.confirmpassword.sameAsPassword && referCode.length != 0"
                  class="validation-invalid-label"
                >
                  {{ $t('Confirm New Passwords must be the same as "Password".') }}
                </div>
              </div>
              <div
                class="form-group"
                id="generate"
              >
                <div class="row">
                  <div class="col-12 col-sm-6">
                    <button
                      type="button"
                      class="col-12 btn btn-outline bg-slate-600 text-slate-600 border-slate-600"
                      @click="generatePassword(8)"
                    >
                      <i class="fa-solid fa-arrows-rotate mr-1" />{{ $t("_Password.Generate Password") }}
                    </button>
                  </div>
                  <div class="col-12 col-sm-6">
                    <button
                      type="button"
                      class="col-12 btn btn-outline bg-slate-600 text-slate-600 border-slate-600"
                      v-clipboard:copy="genPasswordCopy"
                      v-clipboard:success="copySuccess"
                    >
                      <i class="fa-regular fa-copy mr-1" />{{ $t('Copy') }}
                    </button>
                  </div>
                </div>
              </div>
              <div
                class="form-group mt-3 mb-0"
                id="btnChange"
              >
                <div class="text-center">
                  <ladda
                    text="Save"
                    :loading="loading"
                    :btn-class="'btn btn-primary'"
                    :disabled="$v.validationGroup.$invalid"
                    @click="goChangePassword()"
                  />
                  <ladda
                    text="Cancel"
                    :btn-class="'btn btn-light ml-2'"
                    @click="resetvalue"
                    data-dismiss="modal"
                  />
                  <!-- <button class="btn  btn-light" data-dismiss="modal">{{$t("Cancel")}}</button> -->
                </div>
              </div>
            </fieldset>
          </form>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import CentralApi from '@/services/endpoint/central.service';
import { required, minLength, maxLength, sameAs } from "vuelidate/lib/validators";
import { helpers } from 'vuelidate/lib/validators'
import Ladda from '@/plugins/Ladda.vue';

export default {
  components: {
      Ladda
  },
  data() {
      return {
          user: [],
          user_id:'',
          first_name:'',
          password:'',
          user_email:'',
          message:'',
          limit: '',
          times: '',
          loading: false,
          passwordFieldType: 'password',
          confirmpasswordFieldType: 'password',
          iconpassword: 'far fa-eye-slash',
          iconconfirmpassword: 'far fa-eye-slash',
          form: {
              password: '',
              confirmpassword: ''
          },
      };
  },
  props: {
      referCode: {
          type: Array,
          default() {
              return []
          }
      },
  },
  validationConfig: {
      $lazy: true,
  },
  validations: {
      form: {
          password: {
              required,
              uppercase: function(value) {
                  if(this.referCode.length != 0) return true;
                  return /[A-Z]{1}/.test(value);
              },
              lowercase: function(value) {
                  if(this.referCode.length != 0) return true;
                  return /[a-z]{1}/.test(value);
              },
              number: function(value) {
                  if(this.referCode.length != 0) return true;
                  return /[0-9]{1}/.test(value);
              },
              special: function(value) {
                  if(this.referCode.length != 0) return true;
                  if(value.length > 0) {
                      var regex = /^[A-Za-z0-9 ]+$/;
                      for(let special=0,i=0;i<value.length;i++) {
                          if(!regex.test(value[i])) {
                              special++;
                          }
                          if(value.length == (i+1)) {
                              if(special >= 3) {
                                  return true;
                              } else {
                                  return false;
                              }
                          }
                      }
                  } else {
                      return false;
                  }
              },
              continuously: function(value) {
                  if(this.referCode.length != 0) return true;
                  if(value.length > 0) {
                      for(let i=0;i<value.length;i++) {
                          if(i>0 && value[i-1] == value[i]) {
                              return false;
                          } else if(value.length == (i+1)) {
                              return true;
                          }
                      }
                  } else {
                      return true;
                  }
              },
              minLength: minLength(8),
              maxLength: maxLength(16)
          },
          confirmpassword:{
              required,
              sameAsPassword: sameAs("password")
          }
      },
      validationGroup: ['form.password', 'form.confirmpassword']
  },
  methods: {
      genPasswordCopy() {
          let CodeToCopy = document.querySelector('#confirmnewpassword');
          CodeToCopy.setAttribute('type', 'text');
          CodeToCopy.select();
          document.execCommand('copy');
          if(this.iconconfirmpassword == 'far fa-eye-slash') {
              CodeToCopy.setAttribute('type', 'password');
          }
      },
      copySuccess(e) {
          this.$toastr.Add({
              type: "success",
              title: "<span class='t-icon icon-checkmark3'></span>"+this.$t('Success'),
              msg: this.$t('Copy password success.'),
              clickClose: true,
              timeout: 2000,
              position: "toast-top-right"
          });
          this.passwordFieldType = "password";
          this.iconpassword = "far fa-eye-slash";
          this.confirmpasswordFieldType = "password";
          this.iconconfirmpassword = "far fa-eye-slash";
      },
      generatePassword(quantity) {
          let strText = [
              "!@#$%^&*",                     // special
              "ABCDEFGHIJKLMNOPQRSTUVWXYZ",   // uppercase
              "abcdefghijklmnopqrstuvwxyz",   // lowercase
              "1234567890"                    // number
          ];
          let strLength = [3,1,1,1,quantity - 6];
          let ramdomArray = [];
          strLength.forEach(function callback(value, index) {
              while(value > 0) {
                  let numberIndex = index == 4 ? Math.floor(Math.random() * (3 - 1 + 1) + 1) : index;
                  ramdomArray.push(strText[numberIndex].substr(Math.floor(strText[numberIndex].length*Math.random()), 1));
                  if(index == 0 || index == 4) {
                      ramdomArray = ramdomArray.filter((item, i, ar) => ar.indexOf(item) === i);
                      if(index == 0 && ramdomArray.length == 3 || index == 4 && ramdomArray.length == quantity){
                          value = 0;
                      }
                  } else {
                      value = value - 1;
                  }
              }
          });
          this.$v.form.password.$model = ramdomArray.sort(()=>Math.random()-.5).join('');
          this.$v.form.confirmpassword.$model = this.$v.form.password.$model;
          this.passwordFieldType = "text";
          this.iconpassword = "far fa-eye";
      },
      realtime: function(event,key){
          this.$v.form[key].$model = event.target.value;
      },
      async switchVisibiliry() {
          this.passwordFieldType = this.passwordFieldType === 'password' ? 'text': 'password';
          this.iconpassword = this.iconpassword === 'far fa-eye-slash'? 'far fa-eye': 'far fa-eye-slash';
      },
      async confirmswitchVisibiliry() {
          this.confirmpasswordFieldType = this.confirmpasswordFieldType === 'password' ? 'text': 'password';
          this.iconconfirmpassword = this.iconconfirmpassword === 'far fa-eye-slash'? 'far fa-eye': 'far fa-eye-slash';
      },
      async goChangePassword() {
          if(this.$v.validationGroup.$invalid == true) {
              $('#btnChange button.btn.btn-ladda.btn-ladda-spinner.ladda-button.btn.btn-primary').attr('disabled', this.$v.validationGroup.$invalid);
              return;
          }
          this.$v.$touch();
          this.loading = true;
          let params = {
              new_password: this.$v.form.password.$model,
              confirm_password: this.$v.form.confirmpassword.$model,
              typeChange: 'new_password'
          };
          await CentralApi.Auth.changepassword(params).then((res) => {
              setTimeout(() => {
                  $('#ModalNewPassword').modal('hide');
                  location.reload();
              }, 3000);
          },
          error => {
              this.message = error.response.data.message;
              this.limit = error.response.data.limit? error.response.data.limit : '';
              this.times = error.response.data.times? error.response.data.times : '';
              this.loading = false;
          });
      },
      resetvalue() {
          this.$v.$reset();
          const initialData = this.$options.data.call(this);
          Object.assign(this.$data, initialData);
      }
  },
  mounted() {
  }
};
</script>

<style scoped>
  div.validation-invalid-label { display: none !important; }
  div.form-group-error>div.validation-invalid-label { display: block !important; }

  .text-size-13 {
      font-size: 13px !important;
  }

  .input-group > .form-control:focus {
      z-index: 0 !important;
  }

  #generate .btn.btn-outline:hover {
      color: #333 !important;
      background-color: #fafafa;
      border-color: #ddd;
  }

  .icon-mark-2 {
      left: auto;
      right: 45px;
      margin-top: -0.7%;
  }
  
  @media only screen and (max-width: 183px) {
      .icon-mark-2 {right: 0px;}
  }

  .valid-password {
      display: block;
      margin: 0px;
      max-width: 100% !important;
      width: max-content !important;
      bottom: 42px;
      top: auto;
      right: auto;
      left: 550px;
      bottom: -64px;
      z-index: 101;
  }

  .valid-arrow {
      top: 50%;
      margin-top: -2.5px;
  }

  @media only screen and (max-width: 1064px) {
      .valid-password {
          top: auto;
          right: auto;
          left: auto;
          bottom: 45px;
          max-width: 100% !important;
      }
      .valid-arrow {
          top: auto;
          margin-top: 0px;
          left: 45%;
          margin-left: -2.5px;
      }
      .bs-popover-auto[x-placement^=right]>.arrow, .bs-popover-right>.arrow {
          bottom: calc((0.375rem + 1px) * -1);
          width: 0.75rem;
          height: 0.375rem;
          margin: 0 0.25rem;
      }
      .bs-popover-auto[x-placement^=right]>.arrow::before, .bs-popover-right>.arrow::before {
          bottom: 0;
          border-width: 0.375rem 0.375rem 0;
          border-top-color: rgba(0,0,0,.2);
          left: 10%;
          border-right-color: rgb(0 0 0 / 0%);
      }
      .bs-popover-auto[x-placement^=right]>.arrow::after, .bs-popover-right>.arrow::after {
          bottom: 1px;
          border-width: 0.375rem 0.375rem 0;
          border-top-color: #fff;
          border-right-color: rgb(0 0 0 / 0%);
      }
  }
</style>


// WEBPACK FOOTER //
// src/components/central/account/security/ModalNewPassword.vue